// __DAY_GRAPH__ (2026-10-20) the hub's Day graph for this site, with the signed-in person's token (as hubDrafts.js):
// GET /api/board/day-graph?date=YYYY-MM-DD[&all=1] -> {window, rows, no_time, settings, now_min, can_edit_settings}
// POST /api/board/day-graph/settings (owner / CEO) -> the columns' settings, which the Dispatch app reads too.
import { supabase } from '../supabaseClient';
import { HUB } from './hubDrafts';

const token = async () => {
  const { data } = await supabase.auth.getSession();
  return (data && data.session && data.session.access_token) || '';
};

async function call(path, body) {
  const t = await token();
  if (!t) return { ok: false, status: 401, message: 'Not signed in.' };
  try {
    const opt = { headers: { Authorization: 'Bearer ' + t }, redirect: 'manual' };
    if (body !== undefined) { opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    const r = await fetch(HUB + path, opt);
    if (r.type === 'opaqueredirect' || r.status === 0) return { ok: false, status: 401, message: 'The hub did not accept this sign-in.' };
    let j = null;
    try { j = await r.json(); } catch (e) { j = null; }
    if (r.status === 200 && j && j.success) return { ok: true, data: j };
    return { ok: false, status: r.status, message: (j && j.error) || ('The hub answered ' + r.status + '.') };
  } catch (e) {
    return { ok: false, status: 0, message: 'The hub could not be reached (' + ((e && e.message) || 'network') + ').' };
  }
}

export async function fetchDayGraph(day, all) {
  const r = await call('/api/board/day-graph?date=' + encodeURIComponent(day || '') + (all ? '&all=1' : ''));
  return r.ok ? { ok: true, graph: r.data } : r;
}

export async function saveDayGraphSettings(s) {
  const r = await call('/api/board/day-graph/settings', s || {});
  return r.ok ? { ok: true, settings: r.data.settings } : r;
}
